import { Card, CardBody, Col } from 'reactstrap'
import { Finances } from '../../../../utils/Constant'
import ReactApexChart from 'react-apexcharts'
import { financeChart } from '../../../../Data/Widgets/WidgetsChartData'
import CardHeaderCommon from '../../../../CommonElements/CommonCardHeader/CardHeaderCommon'

const Finance = () => {
  return (
    <Col xl="5" lg="12" className="box-col-12">
      <Card>
        <CardHeaderCommon title={Finances} />
        <CardBody>
          <div className="chart-container column-container">
            <ReactApexChart options={financeChart} series={financeChart.series} type="line" height={350}/>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default Finance